<template>
  <div v-if="hasVehicles" :class="['filter-vehicle-selector']">
    <h3 class="h3-bold filter-vehicle-selector__title">
      {{ tStatic('vehicle') }}
    </h3>
    <oie-base-dropdown
      v-model="selectedType"
      :initial-text="tStatic('filterSelectVehicleType')"
      :options="types"
      :is-large="false"
      :use-full-width="true"
      :use-thin-border="true"></oie-base-dropdown>

    <oie-base-dropdown
      v-model="selectedBrand"
      :initial-text="tStatic('filterSelectVehicleBrand')"
      :filter-input-placeholder="tStatic('dropdownFilterPlaceholder')"
      :options="brands"
      :is-large="false"
      :is-disabled="!selectedType"
      :use-wild-card-search="true"
      :use-full-width="true"
      :use-thin-border="true"
      :use-filter-functionality="true"></oie-base-dropdown>

    <oie-base-dropdown
      v-model="selectedModel"
      :initial-text="tStatic('filterSelectVehicleModel')"
      :options="models"
      :filter-input-placeholder="tStatic('dropdownFilterPlaceholder')"
      :is-large="false"
      :is-disabled="!selectedBrand"
      :use-full-width="true"
      :use-wild-card-search="true"
      :use-thin-border="true"
      :use-filter-functionality="true"></oie-base-dropdown>
  </div>
</template>

<script>
import { state, hasVehicles, FILTER_TYPES } from '@/store/filters'
import _ from 'lodash'

export default {
  data() {
    return {
      state,
      selectedType: null,
      selectedBrand: null,
      selectedModel: null
    }
  },
  computed: {
    hasVehicles() { return hasVehicles() },
    types() {
      return state.vehicles.map(v => ({ text: v.name, value: v.id }))
    },
    brands() {
      const type = state.vehicles.find(v => v.id === this.selectedType)
      if (!type) { return [] }
      return type.brands.map(b => ({ text: b.name, value: b.id }))
    },
    models() {
      const type = state.vehicles.find(v => v.id === this.selectedType)
      if (!type) { return [] }
      const brand = type.brands.find(b => b.id === this.selectedBrand)
      if (!brand) { return [] }
      return brand.models.map(m => ({ text: m.name, value: m.modelCode, url: m.url }))
    }
  },
  watch: {
    selectedType() {
      this.selectedBrand = null
      this.selectedModel = null
    },
    selectedBrand() {
      this.selectedModel = null
    },
    selectedModel(newVal, oldVal) {
      state.selectedVehicle = this.selectedModel
      sessionStorage.setItem('lastFacetUsed', JSON.stringify({ type: FILTER_TYPES.vehicle, id: this.selectedModel }))
    }
  },
  async mounted() {
    if(state.selectedVehicle) {
      const models = _.chain(state.vehicles).flatMap(p => p.brands).flatMap(b => b.models).value()
      const selected = models.find(p => p.modelCode === state.selectedVehicle)
      if (!selected) return
      this.selectedType = selected.vehicleType
      await this.$nextTick()
      this.selectedBrand = selected.brandCode
      await this.$nextTick()
      this.selectedModel = selected.modelCode
    }

    this.subscribe('filters-cleared', () => {
      this.selectedType = null
    })
  }

}
</script>

<style lang="scss">
.filter-vehicle-selector {
  display: flex;
  flex-direction: column;
}

.filter-vehicle-selector > *:not(.filter-vehicle-selector__title) {
  flex-grow: 1;
  max-width: initial;
  margin-bottom: measure(quarter);
}

.filter-vehicle-selector .dropdown__options {
  z-index: 4;
}
</style>
